import { Inject, Injectable } from '@angular/core';
import {
	ApolloCache,
	defaultDataIdFromObject,
	InMemoryCache,
	NormalizedCacheObject,
	PossibleTypesMap
} from '@apollo/client';
import { mergeDeepArray } from '@apollo/client/utilities';

import { ApolloCacheManager } from './apollo-cache-manager.service';
import { ApolloTypePolicyProvider, APOLLO_TYPE_POLICY_PROVIDERS } from './apollo-type-policy.provider';

@Injectable({
	providedIn: 'root'
})
export class ApolloCacheFactory {
	constructor(
		@Inject(APOLLO_TYPE_POLICY_PROVIDERS) private readonly typePolicyProviders: ApolloTypePolicyProvider[],
		private readonly apolloCacheManager: ApolloCacheManager
	) {}

	public createCache(name: string, possibleTypes: PossibleTypesMap): ApolloCache<NormalizedCacheObject> {
		const typePolicies = mergeDeepArray(this.typePolicyProviders.map((x) => x.typePolicies()));
		const typenameMap = mergeDeepArray(this.typePolicyProviders.map((x) => x.typenameMap()));
		const cache = new InMemoryCache({
			possibleTypes,
			// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
			dataIdFromObject(responseObject) {
				const typeNameMapper = responseObject.__typename;
				if (typeNameMapper !== undefined && typeNameMapper in typenameMap) {
					return typenameMap[typeNameMapper](responseObject);
				}
				return defaultDataIdFromObject(responseObject);
			},
			typePolicies
		});
		this.apolloCacheManager.addCache(name, cache);
		return cache;
	}
}
